import { render, staticRenderFns } from "./xieyi.vue?vue&type=template&id=76217a4f&"
import script from "./xieyi.vue?vue&type=script&lang=js&"
export * from "./xieyi.vue?vue&type=script&lang=js&"
import style0 from "./xieyi.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports